module.exports = __webpack_public_path__ + "media/application/images/projects/images/canada_lake-39e72c862119a97239ad8bcb47568106.jpg";